import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { financialData, formatCurrency } from '../../data/financialData';

const SalesChart = () => {
  return (
    <div className="bg-gray-900/90 backdrop-blur-md p-6 rounded-xl shadow-2xl border border-green-500/30 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-green-900/20 pointer-events-none" />
      <div className="relative z-10">
      <h3 className="text-xl font-bold text-white mb-6 text-center tracking-wide">Smart Battery Sales (in Millions)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={financialData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis dataKey="year" stroke="#9ca3af" />
          <YAxis tickFormatter={(value) => `${value}M`} stroke="#9ca3af" />
          <Tooltip
            formatter={(value) => formatCurrency(value)}
            contentStyle={{
              backgroundColor: 'rgba(31, 41, 55, 0.95)',
              border: '1px solid #10b981',
              borderRadius: '12px',
              color: '#ffffff'
            }}
            labelStyle={{ fontWeight: 'bold', color: '#ffffff' }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="smartBatterySales"
            name="New Sales"
            stroke="#009b3a"
            strokeWidth={3}
            dot={{ r: 5 }}
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey="returningSubscribers"
            name="Returning Subscribers"
            stroke="#cc0000"
            strokeWidth={2}
            strokeDasharray="5 5"
          />
        </LineChart>
      </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SalesChart;